import { apiClient } from './apiClient';

export type UserNotificationPreferences = {
  tasksEnabled: boolean;
  notifyInApp: boolean;
  notifyByEmail: boolean;
  notifySubordinateTasks: boolean;
  taskPriorities: string[];
  taskEventTypes: string[];
};

export const PLANNING_TASK_PRIORITIES = ['Low', 'Medium', 'High', 'Critical'] as const;

export const PLANNING_TASK_EVENT_TYPES = [
  { id: 'overdue', label: 'Tarefa atrasada' },
  { id: 'status_change', label: 'Mudança de status' },
  { id: 'assignment', label: 'Atribuição de tarefa' },
  { id: 'execution_started', label: 'Início de execução' },
  { id: 'execution_finished', label: 'Conclusão de execução' },
  { id: 'cancelled', label: 'Cancelamento' },
] as const;

export async function fetchNotificationPreferences(): Promise<UserNotificationPreferences> {
  const response = await apiClient.get<UserNotificationPreferences>('/v1/me/notification-preferences');
  return normalizeNotificationPreferences(response.data);
}

export async function saveNotificationPreferences(
  payload: UserNotificationPreferences,
): Promise<UserNotificationPreferences> {
  const response = await apiClient.put<UserNotificationPreferences>(
    '/v1/me/notification-preferences',
    payload,
  );
  return normalizeNotificationPreferences(response.data);
}

function normalizeNotificationPreferences(data: UserNotificationPreferences): UserNotificationPreferences {
  return {
    tasksEnabled: data.tasksEnabled ?? true,
    notifyInApp: data.notifyInApp ?? true,
    notifyByEmail: data.notifyByEmail ?? false,
    notifySubordinateTasks: data.notifySubordinateTasks ?? true,
    taskPriorities: data.taskPriorities ?? [],
    taskEventTypes: data.taskEventTypes ?? PLANNING_TASK_EVENT_TYPES.map((item) => item.id),
  };
}
